import { Box, FormLabel, Input, Text } from "@chakra-ui/react";
import React from "react";

export default function CustomInput({
  label,
  error,
  hideSuccessMessage = false,
  ...rest
}) {
  const validation = error && typeof error === "object" ? error : null;
  const message = validation ? validation.message : error;
  const hasError = validation ? validation.isError : Boolean(error);
  return (
    <Box
      className="custom-form-control"
      data-validation-state={hasError ? "error" : message ? "success" : ""}
    >
      <FormLabel fontSize="sm">{label}</FormLabel>
      <Input
        borderColor={hasError ? "red" : message ? "green" : "gray.300"}
        errorBorderColor="red"
        size="sm"
        {...rest}
      />
      {message && (hasError || !hideSuccessMessage) && (
        <Text
          className="validation-message"
          fontSize="xs"
          color={hasError ? "red" : "green"}
        >
          {message}
        </Text>
      )}
    </Box>
  );
}
